import React from 'react'

import { useTrackOnClick } from '@f/hooks/tracking/useTrackOnClick'

import HouseSmall from './_house-small'
import ImageHeadingDescriptionCTA from './_image-heading-descritpion-cta'

const Card = ({
  tag: Tag,
  className = '',
  href = null,
  template,
  item,
  ...props
}) => {
  let Template = null
  let dataSel = null

  if (template === 'house-small') {
    const propsForHouse = {
      image: item.exterior_images && item.exterior_images[0]['fill-320x240'],
      image_alt: item.exterior_images && item.exterior_images[0]['alt_text'],
      name: item.name,
      usp_label: item.usp_label,
      price_label: item.price_label,
      price: item.price,
      vendor_name: item.vendor_verbose.display_name,
      vendor_logo: item.vendor_verbose.logo.medium,
      item: item
    }

    Template = () => <HouseSmall {...propsForHouse} />
    dataSel = 'crd-house-dflt'

    if (item.usp_label && props.wtData['item']) {
      const nameMapping = {
        next_cheapest: 'cheaper',
        next_biggest: 'bigger',
        bestseller: 'best'
      }

      props.wtData['item'].label = `card-house-standard-${
        nameMapping[item.usp_label]
      }`
    }
  }

  if (template === 'image-heading-description-cta') {
    Template = () => <ImageHeadingDescriptionCTA tag={Tag} {...item} />
  }

  const handleOnClick = event => {
    if (template === 'house-small') {
      const wtData = {
        category: 'item',
        action: 'click',
        values: [{ type: 'house_nid', value: item.nid }],
        ...(props.wtData['item'] ? props.wtData['item'] : {})
      }

      useTrackOnClick({ event, wtData })
    }
  }

  return (
    <Tag
      className={`[ ${
        Tag === 'a' ? 'f-!underline f-shadow-action' : 'f-shadow'
      } f-c-ba-whi f-c-bo-neu025 f-radius-card-large ] Card ${
        props.location === 'HDP' ? 'is-small' : ''
      } js-card ${className}`}
      href={href}
      target={props.target || '_self'}
      data-sel={dataSel}
      onClick={handleOnClick}
      data-wtlab={props.wtData['item'] ? props.wtData['item'].label : ''}
      data-wtloc={props.wtData['item'] ? props.wtData['item'].location : ''}>
      <Template />
    </Tag>
  )
}

export default Card
